import type { MapChartModel } from "../../core/types/charts";

export class ChartModelParser {
  static parse(text: string): MapChartModel {
    const parsed = JSON.parse(text) as Partial<MapChartModel>;
    if (!Array.isArray(parsed.charts)) throw new Error("Chart JSON must contain a charts array.");
    if (!Array.isArray(parsed.legends)) throw new Error("Chart JSON must contain a legends array.");
    return {
      legend_title: parsed.legend_title ?? "Legend",
      legends: parsed.legends,
      unit: parsed.unit ?? "",
      chart_caption: parsed.chart_caption ?? "Chart",
      chart_max_value: parsed.chart_max_value ?? 100,
      charts: parsed.charts.map((chart) => ({
        ...chart,
        unit: chart.unit ?? parsed.unit ?? "",
        chart_caption: chart.chart_caption ?? parsed.chart_caption ?? "Chart",
        chart_max_value: chart.chart_max_value ?? parsed.chart_max_value ?? 100
      }))
    };
  }

  static stringify(model: MapChartModel): string {
    return JSON.stringify(model, null, 2);
  }

  static createTemplate(): MapChartModel {
    return {
      legend_title: "Sample categories",
      legends: [
        { name: "Category A", color: "#2563eb" },
        { name: "Category B", color: "#16a34a" },
        { name: "Category C", color: "#f97316" }
      ],
      unit: "%",
      chart_caption: "Sample chart linked by feature name",
      chart_max_value: 100,
      charts: [
        {
          country_name: "Sample Polygon",
          unit: "%",
          chart_caption: "Sample chart linked by feature name",
          chart_max_value: 100,
          properties: [
            { name: "Category A", value: 72 },
            { name: "Category B", value: 45 },
            { name: "Category C", value: 20 }
          ]
        }
      ]
    };
  }
}
